import React from 'react';
import { logger } from '../utils/logger';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    this.setState({ errorMessage: error?.message || String(error) });
    logger.error('ErrorBoundary', 'Widget crash captured', error, info);
  }

  render() {
    const { hasError, errorMessage } = this.state;
    const { fallback, children } = this.props;

    if (hasError) {
      return fallback || (
        <div style={{
          background: '#fff7ed',
          border: '1px solid #fdba74',
          color: '#9a3412',
          borderRadius: 12,
          padding: 16,
          fontSize: 13,
          fontWeight: 600,
        }}>
          May nagka-aberya sa bahaging ito. I-refresh ang page para subukan ulit.
          {errorMessage && (
            <div style={{ marginTop: 8, fontSize: 11, fontWeight: 400, wordBreak: 'break-all', opacity: 0.8 }}>
              {errorMessage}
            </div>
          )}
        </div>
      );
    }

    return children;
  }
}
